import { Component, HostBinding, Input } from '@angular/core'

@Component({
  selector: 'app-radio-icon',
  templateUrl: './radio-icon.component.html',
  styleUrls: ['./radio-icon.component.scss'],
  standalone: false,
})
export class RadioIconComponent {
  @Input()
  @HostBinding('class.selected')
  selected = false

  @Input()
  label = ''

  get iconSrc(): string {
    return this.selected
      ? '/assets/img/icons/radio-button-selected.svg'
      : '/assets/img/icons/radio-button-unselected.svg'
  }
}
